import { CompanyTheme } from './companyThemes';
import { viralTextTemplate } from './viral-text';
import { keywordFocusTemplate } from './keyword-focus';
import { magazineStyleTemplate } from './magazine-style';
import { gradientModernTemplate } from './gradient-modern';
import { neonGlowTemplate } from './neon-glow';
import { minimalistCleanTemplate } from './minimalist-clean';
import { retroVintageTemplate } from './retro-vintage';
import { geometricBoldTemplate } from './geometric-bold';
import { watercolorSoftTemplate } from './watercolor-soft';
import { techFuturisticTemplate } from './tech-futuristic';
import { handwrittenCasualTemplate } from './handwritten-casual';

export interface TemplateData {
  title: string;
  subtitle: string;
  theme: CompanyTheme;
}

export interface HTMLTemplate {
  id: string;
  name: string;
  description?: string;
  category?: string;
  generate: (data: TemplateData) => string;
}

export const htmlTemplates: HTMLTemplate[] = [
  viralTextTemplate,
  keywordFocusTemplate,
  magazineStyleTemplate,
  gradientModernTemplate,
  neonGlowTemplate,
  minimalistCleanTemplate,
  retroVintageTemplate,
  geometricBoldTemplate,
  watercolorSoftTemplate,
  techFuturisticTemplate,
  handwrittenCasualTemplate
];

export function getRandomTemplate(): HTMLTemplate {
  return htmlTemplates[Math.floor(Math.random() * htmlTemplates.length)];
}

export function getTemplateById(id: string): HTMLTemplate | undefined {
  return htmlTemplates.find(template => template.id === id);
}